/** @format */

import { fromJS } from 'immutable';

const INITIAL_STATE = fromJS({
  isShowing: false,
  isLoading: false,
  isDone: false,
  applicationName: 'Elevator',
  form: {
    path: 'select',
    message: '',
    type: '',
    areaId: '',
    dataTypeCode: '',
    addressNumber: '',
    text: '',
    expanded: false
  },
  error: '',
  validationErrors: {}
});

export default function sendTestAlarmReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'SHOW_SEND_TEST_ALARM_MODAL': {
      return INITIAL_STATE.set('isShowing', true);
    }
    case 'HIDE_SEND_TEST_ALARM_MODAL': {
      return INITIAL_STATE;
    }
    case 'SEND_TEST_ALARM_STARTED': {
      return state.set('isLoading', true);
    }
    case 'SEND_TEST_ALARM_DONE': {
      return state.set('isLoading', false).set('isDone', true).set('error', '');
    }
    case 'SEND_TEST_ALARM_FAILED': {
      return state.set('isLoading', false).set('error', action.payload.msg);
    }
    case 'SEND_TEST_ALARM_FORM_ERRORS': {
      return state
        .set('isLoading', false)
        .set('validationErrors', fromJS(action.payload));
    }
    case 'SEND_TEST_ALARM_INPUT_CHANGE': {
      if (action.payload.name === 'message') {
        return state.setIn(
          ['form', 'expanded'],
          !state.getIn(['form', 'expanded'])
        );
      } else if (
        action.payload.name === 'path' &&
        action.payload.value !== 'select'
      ) {
        const path = action.payload.paths.find(
          (p) => p.get('path') === action.payload.value
        );
        const defaultMessage = path.get('defaultAlarmMessage');
        state = parseMessage(defaultMessage, state);
      } else if (
        action.payload.name === 'path' &&
        action.payload.value === 'select'
      ) {
        state = state.setIn(['form', 'type'], '');
        state = state.setIn(['form', 'areaId'], '');
        state = state.setIn(['form', 'dataTypeCode'], '');
        state = state.setIn(['form', 'addressNumber'], '');
        state = state.setIn(['form', 'text'], '');
        state = state.setIn(['form', 'expanded'], false);
      }
      state = state.setIn(['form', action.payload.name], action.payload.value);
      const message = calculateMessage(state);
      state = state.setIn(['form', 'message'], message);

      return state;
    }
    default: {
      return state;
    }
  }
}

function calculateMessage(state) {
  const type = state.getIn(['form', 'type']);
  const areaId = state.getIn(['form', 'areaId']);
  const dataTypeCode = state.getIn(['form', 'dataTypeCode']);
  const addressNumber = state.getIn(['form', 'addressNumber']);
  const text = state.getIn(['form', 'text']);

  let message = '';
  message += type;
  if (areaId) {
    message += `ri${areaId}/`;
  }
  message += dataTypeCode;
  if (addressNumber) {
    message += `${addressNumber}`;
  }
  if (text) {
    message += `^${text}^`;
  }
  return message;
}

function parseMessage(message, state) {
  const regex =
    /^(.)(?:ri(\d{1,4})\/)?([A-Z]{2})([0-9A-F]{1,4})?(?:\^(.*?)\^)?$/;

  const match = message.match(regex);

  if (!match) {
    throw new Error(`Invalid message format: ${message}`);
  }
  state = state.setIn(['form', 'type'], match[1]);
  state = state.setIn(['form', 'areaId'], match[2] || '');
  state = state.setIn(['form', 'dataTypeCode'], match[3]);
  state = state.setIn(['form', 'addressNumber'], match[4] || '');
  state = state.setIn(['form', 'text'], match[5] || '');

  return state;
}
